import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('localization/region');
  }
}

export default new API();
